export default {"src":"/_next/static/media/sports5.158ed887.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};